export const websocketsEmitActionTypes = {
    WEBSOCKET_EMIT_PASSWORD: "password",
    WEBSOCKET_EMIT_DEVICE_TYPE: "deviceType",
    WEBSOCKET_EMIT_DISCONNECT_TO_ROOM: "disconnectToRoom",
    WEBSOCKET_EMIT_PHONE_DATA: "phoneData",
    WEBSOCKET_EMIT_INTRO_PROGRESSION: "introProgression",
    WEBSOCKET_EMIT_RECONNECT: "reco",
    WEBSOCKET_EMIT_POSITION: "position",
    WEBSOCKET_EMIT_LIGHT_ON: "isLightOn",
    WEBSOCKET_EMIT_SLIDER_VALUE: "sliderValue",
    WEBSOCKET_EMIT_TAP_VALUE: "tapValue",
    WEBSOCKET_EMIT_SHOW_DANGER: "showDanger",
    WEBSOCKET_EMIT_FINGERPRINT: "fingerprint",
    WEBSOCKET_EMIT_CODE: "code",
    WEBSOCKET_EMIT_HANDLE: "handle",
}

export const websocketsOnActionTypes = {
    WEBSOCKET_ON_CONNECT_TO_ROOM: "connectToRoom",
    WEBSOCKET_ON_PASSWORD_ERROR: "passwordError",
    WEBSOCKET_ON_USER_TYPE: "userType",
    WEBSOCKET_ON_DISCONNECT_TO_ROOM: "disconnectToRoom",
    WEBSOCKET_ON_PHONE_DATA: "phoneData",
    WEBSOCKET_ON_CURRENT_STEP: "currentStep",
    WEBSOCKET_ON_SHOW_DANGER: "showDanger",
    WEBSOCKET_ON_ROOM_DISCONNECT: "userDisconnected",
}
